__turbopack_context__.v({
  "close": "i079-G_close",
  "content": "i079-G_content",
  "fallback": "i079-G_fallback",
  "header": "i079-G_header",
  "link": "i079-G_link",
  "popup": "i079-G_popup",
  "scrollArea": "i079-G_scrollArea",
  "trigger": "i079-G_trigger",
});
